import { loginRequest } from '../authConfig';
import { IPublicClientApplication, AccountInfo } from '@azure/msal-browser';

export async function getAccessToken(msalInstance: IPublicClientApplication, account?: AccountInfo): Promise<string> {
    const accounts = msalInstance.getAllAccounts();
    const activeAccount = account || accounts[0];
    if (!activeAccount) throw new Error('No active account found');

    try {
        const response = await msalInstance.acquireTokenSilent({
            ...loginRequest,
            scopes: loginRequest.scopes,
            account: activeAccount,
        });
        return response.accessToken;
    } catch (error) {
        // fallback to interactive if silent fails
        const response = await msalInstance.acquireTokenPopup(loginRequest);
        return response.accessToken;
    }
}
